// Stable per-browser device identifier.
//
// The Web SDK v5 requires the SAME `deviceToken` to be
// passed to `loginOneTimeKey` (bootstrap) and the later
// `loginAccessToken` / `refreshTokens` calls — otherwise
// the renewable token can't be redeemed (see the SDK's
// AccessTokenLoginOptions / RefreshTokenOptions docs). We
// persist one random id per browser in localStorage and
// reuse it across sessions and Inertia navigations.

const STORAGE_KEY = "v2.voice.deviceToken"

function randomId(): string {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID()
  }
  // Fallback for environments without crypto.randomUUID.
  return `dev-${Math.random().toString(36).slice(2)}-${Date.now()}`
}

export function getDeviceToken(): string {
  try {
    const existing = window.localStorage.getItem(STORAGE_KEY)
    if (existing) return existing

    const fresh = randomId()
    window.localStorage.setItem(STORAGE_KEY, fresh)
    return fresh
  } catch {
    // localStorage can throw in private-mode / SSR. Fall
    // back to an ephemeral id — token login simply won't
    // persist across reloads, which degrades to a fresh
    // one-time-key bootstrap each time. Still correct.
    return randomId()
  }
}
